import React, { Component } from "react";

class Persoonsgericht extends Component {
  constructor(props) {
    super(props);

    this.state = {
      case: props.case,
      case2: props.case2,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.case !== this.props.case && this.props.case !== undefined) {
      this.setState({ case: this.props.case });
    }
  }

  render() {
    return (
      <>
        {/* pregunta aditional*/}
        <form className="flex justify-between items-start w-1/2 my-3">
          {this.props.SelectField(
            "Hoe oud ben je :",
            "hoeoud",
            [
              {
                value: 46822,
                label: "18 jaar en ouder (tot 23)",
              },
              {
                value: 46821,
                label: "13 - 17 jaar",
              },
              {
                value: 46820,
                label: "10 - 12 jaar",
              },
            ],
            {
              required: true,
            }
          )}
        </form>

        {/* Caso Persoonsgericht */}
        {/*  <form className="flex justify-between items-start">
          {this.props.handleSelectField(
            "Persoonsgericht:",
            "persoonsgericht",
            [
              {
                value: 46665,
                label: "Individuele begeleiding",
              },
              {
                value: 46664,
                label: "Informatie & Advies",
              },
              {
                value: 46663,
                label: "Online JW",
              },
              {
                value: 46662,
                label: "Peer-to-peer",
              },
            ],
            {
              required: true,
            }
          )}
        </form> */}

        {/*Caso 1 Individuele begeleiding*/}
        {this.state.case === 1 ||
        this.state.case2 === "Individuele begeleiding" ? (
          <form className="grid grid-cols-1 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Ik heb door de activiteiten ontdekt waar ik goed in ben (bijv. sport, muziek, leiderschap)?",
              "begeleiding_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb nieuwe dingen geleerd en gebruik die ook  ",
              "begeleiding_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb succes met waarin ik me ontwikkeld heb  ",
              "begeleiding_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik help mee met de activiteiten.",
              "begeleiding_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb zelf activiteiten mee georganiseerd.  ",
              "begeleiding_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectField(
              "Ik heb iets gedaan voor anderen in de buurt (ja-nee)",
              "begeleiding_6",
              [
                {
                  value: 46670,
                  label: "Nee",
                },
                {
                  value: 46669,
                  label: "Ja",
                },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectField(
              "Ik ben vrijwilliger bij Dynamo (ja-nee)",
              "begeleiding_7",
              [
                {
                  value: 46670,
                  label: "Nee",
                },
                {
                  value: 46669,
                  label: "Ja",
                },
              ],
              {
                required: true,
              }
            )}
            {this.props.opt8
              ? this.props.SelectField(
                  "Nog niet? Ik wil wel vrjwilliger worden (ja-nee)",
                  "meidenwerk_11",
                  [
                    { value: 46670, label: "Nee" },
                    { value: 46669, label: "Ja" },
                  ],
                  { required: true }
                )
              : null}
            {this.props.SelectFieldStar(
              "Ik weet wat goed en slecht gedrag is",
              "begeleiding_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik begrijp hoe anderen mijn gedrag beïnvloeden",
              "begeleiding_10",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik weet wat de gevolgen voor anderen kunnen zijn van mijn gedrag",
              "begeleiding_11",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}

        {/*Caso 2 Informatie & Advies*/}
        {this.state.case === 2 || this.state.case2 === "Informatie & Advies" ? (
          <form className="grid grid-cols-1 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Ik heb door de activiteiten ontdekt waar ik goed in ben (bijv. sport, muziek, leiderschap)?",
              "informatie",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb nieuwe dingen geleerd en gebruik die ook  ",
              "informatie_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb succes met waarin ik me ontwikkeld heb",
              "informatie_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}

        {/*Caso 3 Online JW*/}
        {this.state.case === 3 || this.state.case2 === "Online JW" ? (
          <form className="grid grid-cols-1 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Ik heb door de activiteiten ontdekt waar ik goed in ben (bijv. sport, muziek, leiderschap)?",
              "online",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb nieuwe dingen geleerd en gebruik die ook",
              "online_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb succes met waarin ik me ontwikkeld heb ",
              "online_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik help mee met de activiteiten.",
              "online_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb zelf activiteiten mee georganiseerd.  ",
              "online_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectField(
              "Ik heb iets gedaan voor anderen in de buurt (ja-nee)",
              "online_5",
              [
                {
                  value: 46670,
                  label: "Nee",
                },
                {
                  value: 46669,
                  label: "Ja",
                },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectField(
              "Ik ben vrijwilliger bij Dynamo (ja-nee)",
              "online_6",
              [
                {
                  value: 46670,
                  label: "Nee",
                },
                {
                  value: 46669,
                  label: "Ja",
                },
              ],
              {
                required: true,
              }
            )}
            {this.props.opt8
              ? this.props.SelectField(
                  "Nog niet? Ik wil wel vrjwilliger worden (ja-nee)",
                  "meidenwerk_11",
                  [
                    { value: 46670, label: "Nee" },
                    { value: 46669, label: "Ja" },
                  ],
                  { required: true }
                )
              : null}
            {this.props.SelectFieldStar(
              "Ik weet wat goed en slecht gedrag is",
              "online_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik begrijp hoe anderen mijn gedrag beïnvloeden",
              "online_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik weet wat de gevolgen voor anderen kunnen zijn van mijn gedrag",
              "online_10",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}

        {/*Caso 4 Peer-to-peer*/}
        {this.state.case === 4 || this.state.case2 === "Peer-to-peer" ? (
          <form className="grid grid-cols-2 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Praat je over dingen die voor jou belangrijk zijn tijdens de activiteiten of met de jongerenwerker?",
              "peer_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ervaar je dat anderen naar je luisteren?",
              "peer_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Vraag je om hulp als je het nodig hebt?",
              "peer_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Wordt je goed geholpen door de jongerenwerker?  ",
              "peer_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Help je anderen bij de activiteiten? ",
              "peer_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Voel je je gesteund door andere jongeren?  ",
              "peer_6",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Helpen jullie elkaar in de groep?  ",
              "peer_7",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb vertrouwen in wat ik kan en doe",
              "peer_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik maak mijn eigen keuzes ",
              "peer_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb vertrouwen in mijn eigen keuzes ",
              "peer_10",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}

        {/* pregunta aditional*/}
        <form className="flex justify-between items-start w-2/3 my-3">
          {this.props.TextAreaField(
            "Wat zou je zelf nog kwijt willen aan Dynamo over ons en de jongerenwerkers?",
            "woorden",
            {}
          )}
        </form>
      </>
    );
  }
}

export default Persoonsgericht;
